import React, { FC, useState, useEffect } from "react";
import Button from "../../../components/UI/button/GgButton";
import {
  DocIcon,
  SlashCircleIcon,
  CircleIcon,
  TickCircleIcon,
} from "../../../assets/icons";
import { formatDocName } from "../../../utils";
import { $public } from "../../../http";
import Spinner from "../../../components/UI/spinner/Spinner";

interface IDocsItem {
  values?: any;
  user?: any;
  pathItem?: string;
  actionData?: any
}

const DocsItem: FC<IDocsItem> = ({ values, user, pathItem, actionData }) => {
  const [docStatus, setDocStatus] = useState<any>("");
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setDocStatus(values?.status);
  }, [values]);

  const downloadPropertyReport = async () => {
    let link = document.createElement("a");
    link.target = "_blank";
    link.href = $public(
      `client/account/documents/download${values?.documents}`
    );
    link.click();
    link.remove();
  };

  const updateDocumentStatus = async (status: string) => {
    setLoading(true);
    const data = {
      id: user.selectedUser._id,
      data: {
        status,
      },
      pathObject: pathItem,
    };
    try {
      const res = await user.updateUserDoc(data);
      if (res.modifiedCount === 1) {
        setDocStatus(status);
        setLoading(false);
      }
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  return (
    <div className="doc-card">
      <div className="doc-main">
        <Button
          icon={{ leftIcon: <DocIcon /> }}
          stylesType="round"
          className="download-btn"
          onPress={downloadPropertyReport}
        />
        <div className="doc-info">
          <div className="card-name">{formatDocName(values?.name || "")}</div>
          <div className="dates">
            <span className="created date">Added: {values?.added}</span>
            <span className="updated date">/ Edited: {values?.edited}</span>
          </div>
        </div>
        <div className="indicatior">
          {docStatus === "rejected" ? (
            <SlashCircleIcon />
          ) : docStatus === "confirmed" ? (
            <TickCircleIcon />
          ) : (
            <CircleIcon />
          )}
        </div>
      </div>
      {loading ? (
        <Spinner />
      ) : (
        <div className="controls">
          {actionData?.edit ? (
          <>
            <Button
              disabled={docStatus === "confirmed" || docStatus === "rejected"}
              label="Approve"
              stylesType="border"
              onPress={() => updateDocumentStatus("confirmed")}
            />
            <Button
              label="Reject"
              disabled={docStatus === "confirmed" || docStatus === "rejected"}
              onPress={() => updateDocumentStatus("rejected")}
            />
          </>
): ""}
        </div>
      )}
    </div>
  );
};

export default DocsItem;
